<div class="otp-container" role="group" [attr.aria-label]="ariaLabel()" [class.is-invalid]="invalid()">
  @for (val of otpValues; let idx = $index; track idx) {
    <input
      #otpInput
      type="text"
      inputmode="numeric"
      autocomplete="one-time-code"
      class="otp-box"
      maxlength="1"
      [attr.aria-label]="ariaLabel() + ' ' + (idx + 1)"
      [value]="otpValues[idx]"
      [disabled]="disabled()"
      (input)="onInput($event, idx)"
      (keydown)="onKeyDown($event, idx)"
      (focus)="onFocus($event, idx)"
      (paste)="onPaste($event)"
    />
  }
</div>
